import { OfferElementTile } from "@/models/offer-element-tile.model";

export class OfferElement extends OfferElementTile {
  constructor() {
    super();
    this.content = null;
    this.technologies = null;
  }
}
